import { Inbox } from "lucide-react";

export function EmptyState({ title = "Nada por aqui", description = "Quando houver dados, você verá aqui.", icon: Icon = Inbox, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-6 rounded-xl border border-dashed border-[hsl(var(--border))] bg-white" data-testid="empty-state">
      <div className="w-12 h-12 rounded-full bg-[hsl(var(--secondary))] text-[hsl(var(--primary))] flex items-center justify-center mb-3">
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="font-display font-semibold text-base text-[hsl(var(--primary))]">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
